import { Provider } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { MixpanelService } from './mixpanel.service';
import {
  MIXPANEL_ANALYTICS_CONFIG,
  MixpanelAnalyticsConfig,
} from './mixpanel-analytics-config';

/** Config factory + deps — use when config must read a portal service (e.g. LocaleService). */
export interface MixpanelAnalyticsConfigFactory {
  useFactory: (...deps: any[]) => MixpanelAnalyticsConfig;
  deps?: any[];
}

/** Wires the shared MixpanelService for a portal (binds AnalyticsService + supplies config). */
export function provideMixpanelAnalytics(
  config: MixpanelAnalyticsConfig | MixpanelAnalyticsConfigFactory
): Provider[] {
  const configProvider: Provider =
    'useFactory' in config
      ? {
          provide: MIXPANEL_ANALYTICS_CONFIG,
          useFactory: config.useFactory,
          deps: config.deps ?? [],
        }
      : { provide: MIXPANEL_ANALYTICS_CONFIG, useValue: config };

  return [
    configProvider,
    // useExisting, NOT useClass — useClass creates a second, config-less instance.
    { provide: AnalyticsService, useExisting: MixpanelService },
  ];
}
